import { combineReducers } from 'redux';
//reducers
import auth from './auth';
import authMedia from './auth-media';
import ui from './ui';
import category from './category';
import models from './models';
import sets from './sets';
import orders from './orders';
import messages from './messages';
import pictures from './pictures';
import presentations from './presentations';
import accessories from './accessories';
import categoryAccessories from './category-accessories';
import categoryAdv from './category-adv';
import customer from './customer';

const rootReducer = combineReducers({
	auth,
	authMedia,
  ui,
	category,
	models,
	sets,
	orders,
	messages,
	pictures,
	presentations,
	accessories,
	categoryAccessories,
	categoryAdv,
	customer
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/store/reducers/index.js